import { render, staticRenderFns } from "./CreateTenderDialog.vue?vue&type=template&id=66191196"
import script from "./CreateTenderDialog.vue?vue&type=script&lang=js"
export * from "./CreateTenderDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports